import { EThemeName } from '@wind-log_library/fe-component-library';
import { environment } from 'environments/environment';

export const NAVIGATION_ICONS = [
  {
    key: 'powerplant-navigation-selected',
    [EThemeName.DARK]: 'assets/images/techs/solar-park-light.svg',
    [EThemeName.LIGHT]: 'assets/images/techs/solar-park-dark.svg'
  },
  {
    key: 'storage-navigation-selected',
    [EThemeName.DARK]: `${environment.shared_server}/energy-log/icon-storage-light.svg`,
    [EThemeName.LIGHT]: `${environment.shared_server}/energy-log/icon-storage-dark.svg`
  },
  {
    key: 'park-navigation',
    [EThemeName.DARK]: 'assets/images/techs/wind-park-light.svg',
    [EThemeName.LIGHT]: 'assets/images/techs/wind-park-dark.svg'
  },
  {
    key: 'turbine-navigation',
    [EThemeName.DARK]: 'assets/images/techs/wind-turbine-light.svg',
    [EThemeName.LIGHT]: 'assets/images/techs/wind-turbine-dark.svg'
  },
  {
    key: 'info-icon',
    [EThemeName.DARK]: `${environment.shared_server}/general/main-interface/icon-info-dark.svg`,
    [EThemeName.LIGHT]: `${environment.shared_server}/general/main-interface/icon-info-light.svg`
  }
];
